module.exports = __webpack_public_path__ + "static/media/pin_agenzie_highlighted.1ad5f85c.png";